import { PersonalInformation } from "./components/PersonalInformation/PersonalInformation";
import { SignatoryPreferredMailingAddress } from "./components/SignatoryPreferredMailingAddress";
import { SignatoryEmploymentDetails } from "./components/SignatoryEmploymentDetails";
import { SignatorySourceOfFunds } from "./components/SignatorySourceOfFunds";
import { SignatoryResidenceAddress } from "./components/SignatoryResidenceAddress";
import { GA_EVENTS } from "../../utils/ga";
import { SOURCE_OF_CAPITAL_WEALTH_LABEL } from "./components/SignatorySourceOfFunds/constants";

export const COUNTRY_OF_BIRTH_LABEL = "Country of Birth";
export const PLACE_OF_BIRTH_LABEL = "Place of Birth";

export const FULL_NAME_MAX_LENGTH = 77;
export const STEP_1 = 1;
export const STEP_2 = 2;
export const STEP_3 = 3;
export const STEP_4 = 4;
export const STEP_5 = 5;

export const positionTypes = [
  {
    code: "government",
    key: "government",
    value: "government",
    label: "Government"
  },
  {
    code: "judicial",
    key: "judicial",
    value: "judicial",
    label: "Judicial"
  },
  {
    code: "military",
    key: "military",
    value: "military",
    label: "Military"
  },
  {
    code: "political",
    key: "political",
    value: "political",
    label: "Political"
  }
];
export const YES_NO_OPTIONS = [
  {
    key: "yes",
    code: "yes",
    displayText: "Yes",
    label: "Yes",
    value: "Yes",
    subGroup: null
  },
  {
    key: "no",
    code: "no",
    displayText: "No",
    label: "No",
    value: "No",
    subGroup: null
  }
];

export const stakeHoldersSteps = {
  true: [
    {
      step: STEP_1,
      title: "Home Country Details",
      component: PersonalInformation,
      eventName: GA_EVENTS.COMPANY_STAKEHOLDER_PERSONAL_INFORMATION_CONTINUE
    }
  ],
  false: [
    {
      step: STEP_1,
      title: "Home Country Details and Personal Information",
      component: PersonalInformation,
      eventName: GA_EVENTS.COMPANY_STAKEHOLDER_PERSONAL_INFORMATION_CONTINUE
    },
    {
      step: STEP_2,
      title: "Employment details",
      component: SignatoryEmploymentDetails,
      eventName: GA_EVENTS.FINAL_QUESTION_EMPLOYMENT_CONTINUE
    },
    {
      step: STEP_3,
      title: SOURCE_OF_CAPITAL_WEALTH_LABEL,
      component: SignatorySourceOfFunds,
      eventName: GA_EVENTS.FINAL_QUESTION_SOURCE_OF_FUND_CONTINUE
    },
    {
      step: STEP_4,
      title: "Residence Address",
      component: SignatoryResidenceAddress,
      eventName: GA_EVENTS.FINAL_QUESTION_RESIDENCE_ADDRESS_CONTINUE
    },
    {
      step: STEP_5,
      title: "Office address",
      component: SignatoryPreferredMailingAddress,
      eventName: GA_EVENTS.FINAL_QUESTION_PREFERRED_MAILING_ADDRESS_CONTINUE
    }
  ]
};

export const COMPANY_STAKEHOLDER_ID = "companyStakeholder_";
export const REFTYPE = true;
export const MAX_LICENSE_NUMBER_LENGTH = 20;
export const MAX_REGISTRATION_NUMBER_LENGTH = 12;
export const MAX_REPRESENTED_NAME_LENGTH = 50;

export const SIGNATORY_INITIAL_INDEX = 0;
export const OTHER_OPTION_CODE = "O";
export const MAX_MOTHERS_MAIDEN_NAME_LENGTH = 30;
export const MAX_LENGTH_MARITAL_OTHERS_STATUS = 20;
export const PLACE_OF_BIRTH_LENGTH = 50;
